import { Action } from '../apis';
import { ElementRole, InteractionImportance } from '../types';
import { TEXT_ENTRY_ROLES } from './resolveHost';
import { MarkedImportance } from './sourceAnchor';

const HIGH_ACTIONS = ['create', 'delete', 'transition', 'update'];

const LOW_ACTIONS = ['collapse', 'copy', 'dismiss', 'expand'];

const LOW_ROLES = [
  ...TEXT_ENTRY_ROLES,
  'checkbox',
  'columnheader',
  'menuitem',
  'menuitemcheckbox',
  'menuitemradio',
  'option',
  'switch',
  'tab',
];

const SUBMIT_TAGS = ['BUTTON', 'INPUT'];

const isSubmitHost = (host: Element): boolean =>
  host.tagName === 'FORM' ||
  (SUBMIT_TAGS.includes(host.tagName) &&
    host.getAttribute('type') === 'submit');

export const resolveImportance = ({
  host,
  role,
  action,
  marked,
}: {
  host: Element;
  role: ElementRole | null;
  action: Action | undefined;
  marked: MarkedImportance | null;
}): InteractionImportance => {
  if (
    marked === 'high' ||
    isSubmitHost(host) ||
    (action && HIGH_ACTIONS.includes(action))
  ) {
    return 'high';
  }
  if (
    marked === 'low' ||
    host.hasAttribute('aria-expanded') ||
    (role && LOW_ROLES.includes(role)) ||
    (action && LOW_ACTIONS.includes(action))
  ) {
    return 'low';
  }
  return 'normal';
};
